import { render } from "./DeviceAlarmState.vue?vue&type=template&id=06c399d0&scoped=true"
import script from "./DeviceAlarmState.vue?vue&type=script&lang=js"
export * from "./DeviceAlarmState.vue?vue&type=script&lang=js"

import "./DeviceAlarmState.vue?vue&type=style&index=0&id=06c399d0&scoped=true&language=scss&lang=css"
script.render = render
script.__scopeId = "data-v-06c399d0"

export default script